/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrimaryDiscographyRequestFieldFiltersInner
 */
export interface PrimaryDiscographyRequestFieldFiltersInner {
    /**
     * 
     * @type {string}
     * @memberof PrimaryDiscographyRequestFieldFiltersInner
     */
    field: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrimaryDiscographyRequestFieldFiltersInner
     */
    value?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PrimaryDiscographyRequestFieldFiltersInner
     */
    caseSensitive?: boolean;
}

/**
 * Check if a given object implements the PrimaryDiscographyRequestFieldFiltersInner interface.
 */
export function instanceOfPrimaryDiscographyRequestFieldFiltersInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "field" in value;

    return isInstance;
}

export function PrimaryDiscographyRequestFieldFiltersInnerFromJSON(json: any): PrimaryDiscographyRequestFieldFiltersInner {
    return PrimaryDiscographyRequestFieldFiltersInnerFromJSONTyped(json, false);
}

export function PrimaryDiscographyRequestFieldFiltersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrimaryDiscographyRequestFieldFiltersInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field': json['field'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'caseSensitive': !exists(json, 'case_sensitive') ? undefined : json['case_sensitive'],
    };
}

export function PrimaryDiscographyRequestFieldFiltersInnerToJSON(value?: PrimaryDiscographyRequestFieldFiltersInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field': value.field,
        'value': value.value,
        'case_sensitive': value.caseSensitive,
    };
}

